export function resolveEmulatorConfig(env, hostname) {
  if (env.REACT_APP_USE_FIREBASE_EMULATORS !== "true") return null;
  if (!["localhost", "127.0.0.1", "[::1]"].includes(hostname)) {
    throw new Error("Firebase emulator mode requires a loopback frontend host.");
  }
  const projectId = env.REACT_APP_FIREBASE_EMULATOR_PROJECT || "demo-fq-e2e";
  if (!/^demo-[a-z0-9-]+$/.test(projectId)) {
    throw new Error("Firebase emulator mode requires an isolated demo project.");
  }
  return { projectId, host: "127.0.0.1", authPort: 9099, firestorePort: 8180, functionsPort: 5001, storagePort: 9199 };
}
